var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V18C23 19.6569 21.6569 21 20 21H14C13.4477 21 13 20.5523 13 20C13 19.4477 13.4477 19 14 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44771 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V8C3 8.55229 2.55228 9 2 9C1.44772 9 1 8.55229 1 8V6ZM9 20C9 16.134 5.86599 13 2 13C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11C6.97056 11 11 15.0294 11 20C11 20.5523 10.5523 21 10 21C9.44771 21 9 20.5523 9 20ZM5 20C5 18.3431 3.65685 17 2 17C1.44772 17 1 16.5523 1 16C1 15.4477 1.44772 15 2 15C4.76142 15 7 17.2386 7 20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20ZM3 20C3 20.5523 2.55228 21 2 21C1.44772 21 1 20.5523 1 20C1 19.4477 1.44772 19 2 19C2.55228 19 3 19.4477 3 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromecast);
export default __webpack_public_path__ + "static/media/chromecast.ab2b741972301b35af72ab444abf90a5.svg";
export { ForwardRef as ReactComponent };